'use strict';

exports.__esModule = true;
exports['default'] = component;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _validators = require('../../utils/validators');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function component(target) {
  (0, _validators.validateClass)(target, 'component');

  Object.setPrototypeOf(target.prototype, _react2['default'].Component.prototype);
  Object.setPrototypeOf(target, _react2['default'].Component);
}


//////////////////
// WEBPACK FOOTER
// ./~/react-decoration/lib/decorators/components/component.js
// module id = 545
// module chunks = 1